"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSelect = void 0;
const react_1 = __importDefault(require("react"));
const Checkmark_1 = require("../icons/Checkmark/Checkmark");
const MultipleSelect_styled_1 = require("./MultipleSelect.styled");
const MultipleSelect = (props) => {
    const { items, selected, onClick } = props;
    return (react_1.default.createElement(MultipleSelect_styled_1.MultipleSelectWrapper, null, items.map(({ label, value }) => (react_1.default.createElement(MultipleSelect_styled_1.MultipleSelectItem, { isActive: selected.includes(value), key: value, onClick: () => onClick && onClick(value) },
        label,
        selected.includes(value) && react_1.default.createElement(Checkmark_1.CheckmarkIcon, null))))));
};
exports.MultipleSelect = MultipleSelect;
